{
  "Accessibility Menu": "Tillgänglighetsmeny",
  "Reset settings": "Nollställ inställningar",
  "Close": "Stäng",
  "Content Adjustments": "Anpassa innehåll",
  "Adjust Font Size": "Justera textstorlek",
  "Highlight Title": "Framhäv titel",
  "Highlight Links": "Framhäv länkar",
  "Readable Font": "Läsbart teckensnitt",
  "Color Adjustments": "Anpassa färger",
  "Dark Contrast": "Mörk kontrast",
  "Light Contrast": "Ljus kontrast",
  "High Contrast": "Hög kontrast",
  "High Saturation": "Hög mättnad",
  "Low Saturation": "Låg mättnad",
  "Monochrome": "Monokrom",
  "Contrast": "Kontrast",
  "Invert Colors": "Invertera färger",
  "Tools": "Verktyg",
  "Reading Guide": "Läslinjal",
  "Stop Animations": "Hindra animationer",
  "Big Cursor": "Stor muspekare",
  "Increase Font Size": "Öka textstorlek",
  "Decrease Font Size": "Minska textstorlek",
  "Letter Spacing": "Teckenavstånd",
  "Line Height": "Radhöjd",
  "Font Weight": "Teckensnitt tjocklek",
  "Dyslexia Font": "Dyslektiskt teckensnitt",
  "Language": "Språk",
  "Open Accessibility Menu": "Öppna tillgänglighetsmeny",
  "Widget Settings": "Widget-inställningar",
  "Widget Position": "Widget-position",
  "Top Left": "Övre vänster",
  "Top Center": "Övre mitten",
  "Top Right": "Övre höger",
  "Center Left": "Mitten vänster",
  "Center Right": "Mitten höger",
  "Bottom Left": "Nedre vänster",
  "Bottom Center": "Nedre mitten",
  "Bottom Right": "Nedre höger",
  "Screen Reader": "Skärmläsare",
  "Voice Navigation": "Röstnavigering",
  "Custom Color": "Anpassad färg",
  "Change the site's colors": "Ändra webbplatsens färger",
  "Backgrounds": "Bakgrunder",
  "Headings": "Rubriker",
  "Contents": "Innehåll",
  "Reset colors": "Återställ färger",
  "Image Desaturation": "Avmättnad av bild",
  "Search languages": "Sök språk",
  "No languages found": "Inga språk hittades",
  "Accessibility Profiles": "Tillgänglighetsprofiler",
  "Motor Impaired": "Motorisk begränsning",
  "Big cursor, voice navigation, and no animations.": "Stor markör, röstnavigering och inga animationer.",
  "Blind": "Blind",
  "Screen reader helpers with higher contrast.": "Skärmläsarhjälpmedel med högre kontrast.",
  "Color Blind": "Färgblind",
  "High contrast palette with desaturated media.": "Palett med hög kontrast och dämpade medier.",
  "Dyslexia": "Dyslexi",
  "Friendly font, extra spacing, stronger weight.": "Lättläst typsnitt, extra avstånd och tydligare vikt.",
  "Low vision": "Nedsatt syn",
  "Dark contrast and 130% magnification.": "Mörk kontrast och 130 % förstoring.",
  "Cognitive & Learning": "Kognitivt och lärande",
  "Highlights key sections and enables voice help.": "Markerar viktiga avsnitt och aktiverar röststöd.",
  "Seizure & Epileptic": "Anfall och epilepsi",
  "Stops animations and desaturates imagery.": "Stoppar animationer och tonar ned bilder.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Läsguide, markerade länkar och lugnare färger.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
